module.exports = __webpack_public_path__ + "static/media/edit1.95b1a5b1.png";